/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const SignFieldTextInput16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            d="M14.526 0c.265 0 .474.224.474.494v.556c0 .27-.209.494-.474.494h-1.595v12.911h1.595a.48.48 0 01.468.415l.006.08v.556c0 .27-.209.494-.474.494H9.874a.484.484 0 01-.474-.494v-.556c0-.27.209-.494.474-.494h1.594V1.543H9.874a.48.48 0 01-.468-.414L9.4 1.05V.494c0-.27.209-.494.474-.494zm-5.91 2.81c.602 0 1 .334 1 .888s-.405.887-1 .887H6.418v7.49c0 .702-.412 1.114-1.11 1.114-.699 0-1.11-.412-1.11-1.114v-7.49h-2.19C1.403 4.585 1 4.252 1 3.698s.397-.887 1.007-.887z"
        />
    </AccessibleSVG>
);

export default SignFieldTextInput16;
